module.exports = __webpack_public_path__ + "static/img/partner_12.68132d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par/partner_12.png
// module id = Syk5
// module chunks = 0